require('./style.less');

var Marionette = require('marionette'),
    $ = require('jquery'),
    _ = require('underscore'),
    fvChannel = require('glRadio').channel('FV'),
    FTHeader = require('./header/view'),
    FTFooter = require('./footer/view'),
    FTPages = require('./content/pages/pagesView'),
    TextPgs = require('./content/pages/pgUICollection'),
    ESErrorView = require('./content/error/view');

require('extendJQuery'); //(ajaxErrorMessage)
require('../../../plugin/jquery.inView');
require('../../../plugin/centeredScroll');

var ResizeSensor = require('../../../shim/ResizeSensorShim');


var instanceVars = {
    model: null, //the search model
    state: null,
    lCh: null,
    pgTextCollection: null, //stored here and passed to pages: for hit navigation controlled here
    pagesView: null,
    _scrollbarWidth: null, //cache for SAT calcs
    resizeSensor: null
};


module.exports = Marionette.LayoutView.extend({
    id: 'esResultsDocLevel',
    template: require('./template.hbs'),
    initialize: function (options) {
        _.extend(this, instanceVars, _.pick(options, 'model', 'lCh', 'state'), {
            _scrollbarWidth: fvChannel.request('settings').scrollbarWidth //(cache)
        });
        this.lCh.comply(this.commands, this);
        this.lCh.reply(this.requests, this);
        this.bindEntityEvents(this.state, this.stateCallbacks);
        _.bindAll(this, 'textScrolled', '_bodyClickUnfocusCB');
        /* leave name to remove events*/
        return Marionette.LayoutView.prototype.initialize.apply(this, arguments);
    },
    serializeData: function () {
        return {
            grepMode: this.state.get('grepMode'),
            hideHits: !this.state.get('showHits')
        };
    },
    ui: {
        contentWr:      '.esContentWr',
        scroller:       '.esContentInnerWr',  //the 'scroller' -- not, now its not
        overflowCheck:  '.overflowCheck'
    },
    regions: {
        header:         '#esHeader',
        contentRegion:  '.esContentInnerWr', /* scroller ! */
        footer:         '#esFooter'
    },
    onRender: function () {
        this.unbindKeyboardEvents(); //for select all
    },
    onShow: function ( region, view, options ) {

        this.state.get('fontEmSize') !== 1 && this._updateFontSize(this.state.get('fontEmSize'));
        this._createResizeSensor();

        if ( !this.model.docOnServerAndNoFetchErr() )
            return;

        // DVBC-1147, DVBC-1177 - here DON'T use this.model.numberOfPgsInDoc() (condition where no utr notes returned in resp but there are other hits (doc notes), so there are 'pages')
        if ( this.pgTextCollection.length < 1 )
            return;

        /* quick fix -- aside from better template struct, must be inside to check overflow */
        this.ui.scroller.prepend('<div class="overflowCheck"></div>');
        this.bindUIElements();

        this._postRenderPagesView( _.extend( {}, options, {firstRender: true} ) ); // must pass options, contains

    },
    onBeforeShow: function (region, view, options) {

        var opts = _.pick(this, 'model', 'lCh'); //todo: pass in docOnServer and noFetch to other views

        this.footer.show(new FTFooter(opts));
        /*  center is the conditional -- depends on error -- do first? */

        var noError = this.model.docOnServerAndNoFetchErr();

        /* all errors  -- if err, access pages will result in err */
        if (noError)
            this._createPagesView();   //(also creates pgTextCollection)

        this.contentRegion.show( noError ? this.pagesView : new ESErrorView(_.pick(this, 'model', 'lCh')) );

        //b/c no yet shown, don't filter elements on visible here ... would need to do onShow
        this.header.show( new FTHeader( _.extend(opts, {
            $searchContainer: noError ? this._$getSearchContainer() : $(), /* can't give the individual jq elements from the children (closest) but don't include not pages */
            pgTextCollection: noError ? this.pgTextCollection : undefined //(if error, pg text collection (created with pages view, not created; conditional left for clarity)
        })));

        //(run any provided 'onAfterRender' if there was one -- applicable to doc not on server or err fetching model;
        // (if doc not on server / error occured -- the success runs on highligh of first hit)
        !noError && options && options.cb && options.cb({
            jqXHR: this.model.getFetchErr(),
            docNotOnServer: this.model.docNotOnESServer()
        });
    },
    events: {
        click:      'onClick',
        mouseover:  'onMouseover'
    },
    keyboardEvents: {
        'mod+a': 'selectAll' //mod if mac/pc
    },
    _destroyAndCreatePagesView: function () {
        this._destroyPagesView();
        this._createPagesView();
        this.contentRegion.show(this.pagesView);
    },
    //TODO: consolidate code from the 3 below
    _postToggleESGrepMode: function () {
        this._destroyAndCreatePagesView();
        this._postRenderPagesView({fromGrepToggle: true});
        this.lCh.trigger('updateGrepToggleBtnState', this.state.get('grepMode'));
    },
    _postToggleLocalGrepMode: function (m, mode, options) {
        this._destroyAndCreatePagesView();
        this._postRenderPagesView( _.extend( {}, options, {fromGrepToggle: true} )  ); //options could have highlightHitIndex
    },
    _postKeyUpInLocalGrepMode: function() {
        // need to re-render/reset -- and then have search bar activate the hit, THEN,
        // scroll to it -- having the 2 fns avoids recursions of calling keyup when hit is highlighted
        // TODO -- overlap with post toggle local grep mode fn
        this._destroyAndCreatePagesView();
        this._postRenderPagesView({fromGrepToggle: true}); //calls set hits ...
    },
    _postToggleSimpleMode: function() {
        this._destroyAndCreatePagesView();
        this._postRenderPagesView({ fromSimpleModeToggle: true });
    },
    _postRenderPagesView: function(options) {

        var numberOfPgs = this.pgTextCollection.length;
        /* must set the top and bottoms before set hits (or do any scrolling to page) */
        /* note: IE8 wont be correct until the viewer loads */

        this.lCh.command('calcPageBottoms'); //(always do even if 1 page)

        //scroll to the current page position first, knowing that if there is a hit, state.setHits will scroll to the first page with a hit
        this.silentScrollToPage(this.state.get('currentPg')); //TODO: necessary?

        //(triggers navigation to active hit, and page change)
        this.state.setHits(this.$el, {
            initialLoadCallback: options && options.cb, //on show really show happen after scrolling/hit highlighting, etc (eg: to get the active page)
            fromGrepToggle: options && options.fromGrepToggle,
            fromSimpleModeToggle: options && options.fromSimpleModeToggle
        });

        //TODO: for simplicity all below could be put in set hit callback

        //(run in case their was no active hit to fire the other cb */
        (this.state.getActiveHit().length < 1) && (options && options.cb) && options.cb();

        /* don't allow scroll events to get picked up if only one page --- move up?*/
        if (numberOfPgs > 1) this.toggleScrollCB(true);
        /* not on events hash b/c scroll event doesn't bubble*/

        if (options && (options.fromGrepToggle || options.fromSimpleModeToggle || options.firstRender)) { //(first render b/c doc change could come in one of these modes)

            var nHits = this.state.getNumberOfHits();

            /* update number of hits in viewer header */

            this.lCh.trigger('navView:update', this.state.get('activeHitNumber'), nHits);
            this.lCh.trigger('fullText:updateNoteCountAndCaption', nHits, this.model.getSearchTxt(), this.state.get('localGrepMode') ? this.state.get('localSearchText') : null ); /* vChannel export */
            this.lCh.trigger('header:updatePageSelector', this.pgTextCollection, this.state.get('currentPg'));

            if (!options.firstRender) {

                this.lCh.trigger('header:updateSearchBarAfterPageViewRender', this._$getSearchContainer(),
                    options && (options.highlightHitIndex || options.highlightHitIndex === 0) //DVBC-1284: later predicates b/c it can be 0 if its the first hit!
                        ? options.highlightHitIndex
                        : null
                );
            } else {
                //if local hit, scroll to it -- if hits, the first hit would have been scrolled to
                var $localHit = this.$el.find('.sbActive');
                $localHit.length > 0 && this._scrollToLocalHitIfInView($localHit);
            }

        }
    },
    _createPagesView: function () {

        var simpleMode = this.state.get('simpleMode'),
            grepMode = this.state.get('grepMode'),
            localGrepMode = this.state.get('localGrepMode'),
            localSearchTxt = this.state.get('localSearchText'),

            localGrepSearch = localGrepMode ? localSearchTxt : null,

            // TODO: call this metadata -- this would consist of FC Fields, Doc Props, & RMA that comes
            // off the source that is non existent (undefined) if not found
            includeNonFieldHitsOrDocProps = grepMode ? false : !simpleMode; 

        var pgTextObjs = this.model.getPageTextObjs(grepMode, localGrepSearch);

        var fieldHits = this.model.getFCFields(localGrepSearch, includeNonFieldHitsOrDocProps);
        fieldHits && pgTextObjs.push({
            pgViewType: 'FC_FIELDS',
            pgText: fieldHits
        });

        var securityProperties = this.model.getSecurityOrRMAProperties(localGrepSearch, includeNonFieldHitsOrDocProps, 1);
        securityProperties && pgTextObjs.push({
            pgViewType: 'SECURITY_PROPS',
            pgText: securityProperties
        });

        var rmaProperties = this.model.getSecurityOrRMAProperties(localGrepSearch, includeNonFieldHitsOrDocProps);
        rmaProperties && pgTextObjs.push({
            pgViewType: 'RMA_PROPS',
            pgText: rmaProperties
        });

        var docPropHits = this.model.getDocProperties(localGrepSearch, includeNonFieldHitsOrDocProps);
        docPropHits && pgTextObjs.push({
            pgViewType: 'DOC_PROPS',
            pgText: docPropHits
        });

        var docNoteHits = this.model.getDocNotes(grepMode, localGrepSearch, includeNonFieldHitsOrDocProps);
        docNoteHits && pgTextObjs.push({
            pgViewType: 'DOC_NOTES',
            pgText: docNoteHits
        });


        this.pgTextCollection = new TextPgs(pgTextObjs);
        
        this.pagesView = new FTPages({
            collection: this.pgTextCollection,
            model: this.model,
            lCh: this.lCh,
            state: this.state
        });

    },
    //(as well as pg text collection)
    _destroyPagesView: function () {
        //MOST FINALLY GONE ... can clean
        this.lCh.stopComplying('searchBar:localHitActivated'); //prevent mem leak -- $hit callback in context

        this.state.cleanHits();

        var pgsView = this.pagesView,
            headerView = this.header.currentView,
            searchBarView = headerView.children.findByCustom('searchBar'); //TODO: mediate

        pgsView.$el.find('*').remove();
        pgsView.$el.remove();

        searchBarView.searchUI.destroy();

        if (searchBarView.$domToHighlight) {
            searchBarView.$domToHighlight.remove();
            searchBarView.$domToHighlight = null;
        }

        // after first time, this will no longer exist
        if (searchBarView.options.$searchContainer) {
            searchBarView.options.$searchContainer.remove();
            searchBarView.options.$searchContainer = null;
        }

        if (headerView.options.$searchContainer) {
            headerView.options.$searchContainer.remove(); //TODO: STILL NECESSARY? -- JUST REMOVE ONE REF (NOW IT'S NOT AN ATTR)?
            headerView.options.$searchContainer = null;
        }

        this.contentRegion.empty();
        Marionette.blindTriggerOn([this.pagesView, this.pgTextCollection], 'destroy');

        pgsView.el = null;

        this.lCh.comply('searchBar:localHitActivated', this);
    },
    //TODO: MOVE UP
    stateCallbacks: {
        'change:activeHitNumber':   'hitActivated', /* now also implies content changed -- 'hitsSet' */
        'change:currentPg':         'pageChanged',
        'change:grepMode':          '_postToggleESGrepMode',
        'change:localGrepMode':     '_postToggleLocalGrepMode',
        'change:simpleMode':        '_postToggleSimpleMode',
        'change:showHits': function (m, show) {
            this.lCh.trigger('navView:toggleHits', show);
            this.ui.contentWr.toggleClass('hideHits', !show); //(class on here, not pageViews -- move */
        },
        'change:wrapText': function (state) {
            this._createResizeSensor(); //will existing destroy if not wrapped

            this.pagesView.triggerMethod('wrapTextToggle');
            //if not in view, scroll to active hit (if there are hits)
            this.model._hasAnyResults() && this.hitActivated(state, state.get('activeHitNumber'));
        },
        'change:fontEmSize': function (m, size) {
            this._updateFontSize(size);
            this.lCh.command('calcPageBottoms');
        },
        'change:searchInputEnabled': function () {
            var newSearchView = this.footer.currentView.center.currentView,
                args = _.toArray(arguments);
            newSearchView.triggerMethod.apply(newSearchView, ['toggleSearchReset'].concat(args));
        }
    },
    pageChanged: function (m, pgNum, options) {

        var fromViewer = options.fromViewer;

        if (options.fromScroll || options.fromResize || options.fromHitChange || options.fromLocalHitChange || options.fromSimpleModeToggle || fromViewer) { /* already scrolled (not viewer) */
            this.lCh.trigger('header:setSelectPgNumber', pgNum);
        }

        if (options.fromSelect || fromViewer) {
            this.silentScrollToPage(pgNum);
        }

        if (!options.fromViewer) {
            this.lCh.trigger('fullText:changePage', pgNum);  /* forwarded (export)*/
        }

        //(below here is the end of the 'onShow' workflow chain of events ...
        options && options.initialLoadCallback && options.initialLoadCallback();

    },
    /* if scrolled, indicate a change in page if it occurs */
    textScrolled: function () {

        var state = this.state,
            curScrTop = this.ui.scroller.scrollTop(),
            dy = curScrTop - state.get('lastScrollTop'),
            curPgNum = this.lCh.request('currentPgNumber'),  //here, really implies the last page
            pages = this.pgTextCollection;

        state.set('lastScrollTop', curScrTop);

        if (dy === 0) return;

        if (dy > 0) { //scrolldown

            var currentPgBottom = pages.findWhere({pgNum: curPgNum}).get('bottom');
            (curScrTop > currentPgBottom) && setCurrentPg();

        } else if (dy < 0) {

            var currentPgTop = pages.findWhere({pgNum: curPgNum}).get('top');
            (curScrTop < currentPgTop) && setCurrentPg();
        }

        function setCurrentPg() {
            var pageOn = pages.getByScrollPosition(curScrTop);
            pageOn && state.set('currentPg', pageOn.get('pgNum'), {fromScroll: true});
        }

    },
    toggleScrollCB: function (on) {
        /* note: this is working but still need to defer any scroll callbacks */
        this.ui.scroller.jquery /*only do when rendered -- may not exist on fast reset */
        && this.ui.scroller[on ? 'on' : 'off']('scroll', this.textScrolled);
    },
    /* scrolls, but turn off scroll listener */
    silentScrollToPage: function (pgNum) {

        this.toggleScrollCB(false);

        var scrollToPage = this.pgTextCollection.findWhere({pgNum: pgNum});
        scrollToPage && this.ui.scroller.scrollTop(scrollToPage.get('top')).scrollLeft(0);
        //todo: set last scroll top?

        _.defer(function (cxt) {
            cxt.toggleScrollCB(true);
        }, this);
    },
    /* used for select all -- will need accessibility high level org TODO: obviously needs reorg */
    onClick: function (e) {

        e.stopPropagation();
        var $target = $(e.target);

        //TODO: MAKE DUMMY FOCUS A STATE, W/CB -- also make actual focus like in the key-focus branch

        this.ui.contentWr.addClass('dummyFocus');
        this.bindKeyboardEvents(); //allow the select all -- todo: to parent
        $('body').one('click', this._bodyClickUnfocusCB);

        if ($target.hasClass('hit') && this.state.get('grepMode')) {
            this.state.setActiveHitIndex($target);
            this.lCh.command('toggleGrepMode');
        }

        //now handling here, not in plugin -- less listeners & perf boost
        if ($target.hasClass('highlight') && this.state.get('localGrepMode')) {
            this.lCh.command('toggleLocalGrepMode', {
                highlightHitIndex: this.$('.highlight').index($target) //TODO: could now just pass a flag
            });
        }

    },
    /* now just a deleted way to put tooltips on the hover of grepped hits -- not printing the titles on render of the text coming back from es */
    /* note: not taking away with mouseout */
    onMouseover: function (e) {
        e.stopPropagation();

        var $target = $(e.target);

        if (this.state.get('grepMode') && $target.hasClass('hit')) {
            $target.attr('title', 'View in non-grepped text context');
            return;
        }

        if (this.state.get('localGrepMode') && $target.hasClass('highlight')) {
            $target.attr('title', 'View in non-grepped text context');
            return;
        }

    },
    /* here to avoid leak */
    _bodyClickUnfocusCB: function () {
        this.ui.contentWr.removeClass('dummyFocus');
        this.unbindKeyboardEvents(); //revert to the norm
    },
    selectAll: function (e) {
        !e.preventDefault && (e = $.event.fix(e));
        e.preventDefault();
        this.ui.contentWr.selectAll();
    },
    hasYOverflow: function () {
        return this.ui.contentWr.height() > this.ui.overflowCheck.height();
    },
    hasXOverflow: function () {
        return this.ui.contentWr.width() > this.ui.overflowCheck.width();
    },
    _updateFontSize: function (size) {
        this.ui.contentWr.css('font-size', size + 'em');
    },
    requests: {
        showHitsInView: function () {
            return this.state.get('showHits');
        },
        isInGrepMode: function () {
            return this.state.get('grepMode');
        },
        inLocalGrepMode: function() {
            return this.state.get('localGrepMode');
        },
        isInSimpleMode: function() {
            return this.state.get('simpleMode');
        },
        isTextWrapped: function () {
            return this.state.get('wrapText');
        },
        currentPgNumber: function () {
            return this.state.get('currentPg');
        },
        scrollPositionRatio: function () {
            var $pgsEl = this.pagesView.$el,
                $scroller = this.contentRegion.$el;
            return {
                top: $scroller.scrollTop() / $pgsEl.height(),
                left: $scroller.scrollLeft() / $pgsEl.width()
            };
        },
        getLocalSearchTxt: function () {
            return this.state.get('localSearchText');
        },
        currentHitNumber: function () {
            return this.state.get('activeHitNumber');
        }
    },
    commands: {
        hitButtonClick: function (action) {
            this.state.navigateHits(action);
        },
        showHits: function () {
            this.state.toggle('showHits');
        },
        toggleTextWrapping: function () {
            this.state.toggle('wrapText');
        },
        selectAll: function () {
            this.selectAll.apply(this, arguments);
        },
        changeFontSize: function () {
            this.state.changeFontSize.apply(this.state, arguments);
        },
        toggleSearchBarState: function () {
            this.state.toggle('searchInputEnabled');
        },
        'pageSelect:pageChange': function (pgNum) {
            this.state.set('currentPg', pgNum, {fromSelect: true});
        },
        'searchbar:focused': function() {
            this._updateCachedViewCalcs();
        },
        toggleGrepMode: function () {
            this.state.toggle('grepMode');
        },
        toggleSimpleMode: function() {
            this.state.toggle('simpleMode');
        },
        toggleLocalGrepMode: function (options) {
            options && options.searchTxt && this.state.set('localSearchText', options.searchTxt, {silent: true});
            this.state.toggle('localGrepMode', options);
        },
        'searchBar:localHitActivated': function ($hit) {
            this._scrollToLocalHitIfInView($hit);
        },
        'searchbar:postKeyupInGrepMode': function (searchTxt) {
            this.state.set('localSearchText', searchTxt, {silent: true}); //todo: perf issue?
            this._postKeyUpInLocalGrepMode.apply(this, arguments);
        },
        'searchBar:collapsed': function () {
            this.state.set('localSearchText', '');
        },
        'searchBar:postKeyUpNotGrepMode': function(localSearchTxt) {
            this.state.set('localSearchText', localSearchTxt, {silent: true});
        },
        setScrollPosition: function (scrollRatio) {
            var $pgsEl = this.pagesView.$el;
            this.contentRegion.$el
                .scrollTop(scrollRatio.top * $pgsEl.height())
                .scrollLeft(scrollRatio.left * $pgsEl.width());
        }
    },
    _updateCachedViewCalcs: function() {
        /* Cache dimension values for SAT perf boost */
        _.extend(this, {
            _hasYOverflow: this.hasYOverflow(),
            _hasXOverflow: this.hasXOverflow(),
            _scrollerOffsets: this.ui.scroller.getOffsets()
        });
    },

    /* really from the set hits now */
    hitActivated: function (state, hitIdx, options) {
        this.lCh.trigger('navView:updateHitCount', hitIdx); //todo: also update number?
        /* scroll to it if exists */
        var $hit = state.$hits.eq(hitIdx);
        $hit.length > 0 && this._activateHitIfInView($hit, options);
    },
    _activateHitIfInView: function ($hit, options) {
        /* note: already marked in model */
        var hitInView = $hit.inView( this.ui.scroller, {
                yOverflow: this.hasYOverflow(),
                xOverflow: this.hasXOverflow(),
                scrollBarWidth: this._scrollbarWidth
            });

        hitInView
            ? setPgNumber.call(this)
            : this.silentCenteredScrollToHit( $hit, _.bind( setPgNumber, this) ) ;

        function setPgNumber() {
            this.state.attributes && this.state.set('currentPg', this.getPageOfHit($hit), {
                fromLocalHitChange: true
            });
            options && options.initialLoadCallback && options.initialLoadCallback();
        }

    },
    //TODO: combo code w/ES hit scroll ...
    _scrollToLocalHitIfInView: function ($hit) {
        /* (its already highlighted by the plugin -- also set the page number */

        var hitInView = $hit.inView( null, {
            yOverflow: this._hasYOverflow,
            xOverflow: this._hasXOverflow,
            scrollBarWidth: this._scrollbarWidth,
            containerOffsets: this._scrollerOffsets
        });

        hitInView
            ? setPgNumber.call(this)
            : this.silentCenteredScrollToHit( $hit, _.bind( setPgNumber, this) ) ;


        function setPgNumber() {
            this.state.attributes && this.state.set('currentPg', this.getPageOfHit($hit), {
                fromLocalHitChange: true
            });
        }
    },
    silentCenteredScrollToHit: function ($hit, cb) {
        var pgNumOfHit = this.getPageOfHit($hit),
            pg = this.pgTextCollection.findWhere({pgNum: pgNumOfHit}),
            prevPgTop = pg.get('top');

        this.toggleScrollCB(false);
        $hit.centeredScroll(this.ui.scroller, prevPgTop, null, _.bind(function () {
            this.toggleScrollCB(true);
            cb && cb();
        }, this));
    },
    //(can be find/search )
    getPageOfHit: function ($hit) {
        return $hit.closest('.esPage').data('page-num');
    },

    //note: only done in wrapText and if more than 1 page
    _createResizeSensor: function () {

        if (this.resizeSensor)
            this.resizeSensor.detach();

        if (this.model.numberOfPgsInDoc() > 1 && this.state.get('wrapText')) {

            var lCh = this.lCh;
            var self = this;

            this.resizeSensor = new ResizeSensor(this.el, _.debounce(function () {

                lCh.command('calcPageBottoms');
                var pageOn = self.pgTextCollection.getByScrollPosition(self.ui.scroller.scrollTop());
                self.state.set('currentPg', pageOn.get('pgNum'), {fromResize: true});

            }, 20, true));
        }
    },
    _$getSearchContainer: function () {
        return this.pagesView.$el.find('.esPageText'); //TODO: NO CONTEXT, SPEED UP? ... though the selector should be fast here
    },
    onBeforeDestroy: function () {

        this.resizeSensor && this.resizeSensor.detach();

        this.$('*').remove();

        $('body').off('click', this._bodyClickUnfocusCB); //(this fixed the leak on re-search)
        this.lCh.reset();
        this.unbindEntityEvents(this.state, this.stateCallbacks);
        Marionette.blindTriggerOn([this.pgTextCollection, this.state, this.pagesView, this.model], 'destroy');
        /* not there if err  */

        this.off();
        this.stopListening();
        this.$el.remove();

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/layout.js
 ** module id = 524
 ** module chunks = 0
 **/